import React, { useState, useEffect, useCallback } from 'react';
import pb from '../../../lib/pocketbase';
import './Messages.css';

const Messages = () => {
    const [messages, setMessages] = useState([]);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');

    const fetchMessages = useCallback(async () => {
        setLoading(true);
        try {
            const result = await pb.collection('messages').getList(1, 100, {
                sort: '-created',
            });
            setMessages(result.items);
            if (result.items.length > 0 && !selectedMessage) {
                // setSelectedMessage(result.items[0]);
            }
        } catch (err) {
            console.error('Error fetching messages:', err);
        } finally {
            setLoading(false);
        }
    }, [selectedMessage]);

    useEffect(() => {
        fetchMessages();
    }, [fetchMessages]);

    const handleSelectMessage = async (msg) => {
        setSelectedMessage(msg);
        if (msg.status === 'new') {
            try {
                const updated = await pb.collection('messages').update(msg.id, { status: 'read' });
                setMessages(prev => prev.map(m => m.id === msg.id ? updated : m));
            } catch (err) {
                console.error(err);
            }
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Supprimer ce message définitivement ?')) return;
        try {
            await pb.collection('messages').delete(id);
            setMessages(prev => prev.filter(m => m.id !== id));
            if (selectedMessage?.id === id) setSelectedMessage(null);
        } catch (err) {
            console.error(err);
        }
    };

    const handleArchive = async (id) => {
        try {
            const updated = await pb.collection('messages').update(id, { status: 'archived' });
            setMessages(prev => prev.map(m => m.id === id ? updated : m));
            if (selectedMessage?.id === id) setSelectedMessage(updated);
        } catch (err) {
            console.error(err);
        }
    };

    const filteredMessages = messages.filter(m => {
        if (filter === 'all') return m.status !== 'archived';
        if (filter === 'archived') return m.status === 'archived';
        if (filter === 'new') return m.status === 'new';
        return true;
    });

    if (loading && messages.length === 0) {
        return <div className="admin-content-wrapper">Chargement des messages...</div>;
    }

    return (
        <div className="admin-content-wrapper messages-panel">
            <div className="messages-layout">
                {/* List Panel */}
                <div className="messages-sidebar">
                    <div className="sidebar-header-actions">
                        <h2>Messages</h2>
                        <div className="filter-pills">
                            <button className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>Actifs</button>
                            <button className={filter === 'new' ? 'active' : ''} onClick={() => setFilter('new')}>Nouveaux</button>
                            <button className={filter === 'archived' ? 'active' : ''} onClick={() => setFilter('archived')}>Archive</button>
                        </div>
                    </div>

                    <div className="messages-list scrollbar-hide">
                        {filteredMessages.length === 0 ? (
                            <div className="empty-state">Aucun message trouvé</div>
                        ) : (
                            filteredMessages.map(msg => (
                                <div 
                                    key={msg.id} 
                                    className={`message-item ${selectedMessage?.id === msg.id ? 'selected' : ''} ${msg.status === 'new' ? 'unread' : ''}`}
                                    onClick={() => handleSelectMessage(msg)}
                                >
                                    <div className="msg-header">
                                        <span className="msg-author">{msg.firstName} {msg.lastName}</span>
                                        <span className="msg-date">{new Date(msg.created).toLocaleDateString('fr', { day: 'numeric', month: 'short' })}</span>
                                    </div>
                                    <div className="msg-subject">{msg.email}</div>
                                    <div className="msg-snippet">{msg.message}</div>
                                    {msg.status === 'new' && <span className="new-indicator"></span>}
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* Content Panel */}
                <div className="message-content">
                    {selectedMessage ? (
                        <div className="msg-view">
                            <div className="msg-view-header">
                                <div className="msg-info-group">
                                    <h3>{selectedMessage.firstName} {selectedMessage.lastName}</h3>
                                    <div className="msg-meta">
                                        <span>📧 {selectedMessage.email}</span>
                                        {selectedMessage.phone && <span>📞 {selectedMessage.phone}</span>}
                                        <span>🕒 {new Date(selectedMessage.created).toLocaleString('fr')}</span>
                                    </div>
                                    {selectedMessage.subject && (
                                        <div className="msg-badge-subject" style={{ marginTop: '0.5rem', display: 'inline-block', padding: '0.2rem 0.6rem', background: '#f1f5f9', borderRadius: '6px', fontSize: '0.75rem', color: '#475569', fontWeight: '600' }}>
                                            OBJET : {selectedMessage.subject}
                                        </div>
                                    )}
                                </div>
                                <div className="msg-actions">
                                    <button 
                                        className="icon-btn" 
                                        title="Répondre"
                                        onClick={() => window.open(`mailto:${selectedMessage.email}?subject=RE: Votre demande L'Univers Diag`)}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path></svg>
                                    </button>
                                    <button 
                                        className="icon-btn" 
                                        title="Archiver"
                                        onClick={() => handleArchive(selectedMessage.id)}
                                        disabled={selectedMessage.status === 'archived'}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line></svg>
                                    </button>
                                    <button 
                                        className="icon-btn delete" 
                                        title="Supprimer"
                                        onClick={() => handleDelete(selectedMessage.id)}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                                    </button>
                                </div>
                            </div>

                            <div className="msg-body-wrapper">
                                <div className="msg-body-text">
                                    {selectedMessage.message}
                                </div>
                            </div>

                            <div className="msg-quick-reply">
                                <textarea placeholder="Écrire une note interne ou préparer une réponse..." className="custom-input"></textarea>
                                <div className="reply-actions">
                                    <button className="secondary-button">Note interne</button>
                                    <button className="primary-button" onClick={() => window.open(`mailto:${selectedMessage.email}`)}>Répondre par Email</button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="msg-no-selection">
                            <div className="no-selection-icon">📩</div>
                            <p>Sélectionnez un message pour lire le contenu</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Messages;
